"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _selectedItems = _interopRequireDefault(require("../selected-items"));
var _styles = require("../styles");
const MultiSelectDropdownInput = _ref => {
  let {
    selectedItems,
    placeholder,
    getToggleButtonProps,
    getRemoveButtonProps,
    removeItem,
    itemToString,
    disabled,
    containsErrors,
    actionIconsPadding,
    inputProps
  } = _ref;
  return (
    /*#__PURE__*/
    // This needs to use a div instead of a button so that click events
    // propagate down to the child RemoveItemIcons in IE11. In IE11
    // click events are captured by button elements which blocks
    // clicks on any child elements. Reference:
    // https://stackoverflow.com/a/43790392
    _react.default.createElement(_styles.GreyBox, getToggleButtonProps({
      useTypeahead: false,
      onKeyDown(event) {
        if (event.key === 'Backspace') {
          removeItem(selectedItems[selectedItems.length - 1]);
        }
      },
      disabled: disabled,
      containsErrors: containsErrors,
      actionIconsPadding: actionIconsPadding,
      ...inputProps
    }), selectedItems.length > 0 ? /*#__PURE__*/_react.default.createElement(_selectedItems.default, {
      items: selectedItems,
      itemToString: itemToString,
      getRemoveButtonProps: getRemoveButtonProps,
      disabled: disabled
    }) : /*#__PURE__*/_react.default.createElement(_styles.StyledPlaceholder, null, placeholder))
  );
};
MultiSelectDropdownInput.propTypes = {
  actionIconsPadding: _propTypes.default.any,
  containsErrors: _propTypes.default.any,
  disabled: _propTypes.default.any,
  getRemoveButtonProps: _propTypes.default.any,
  getToggleButtonProps: _propTypes.default.func,
  inputProps: _propTypes.default.any,
  itemToString: _propTypes.default.any,
  placeholder: _propTypes.default.any,
  removeItem: _propTypes.default.func,
  selectedItems: _propTypes.default.array
};
var _default = exports.default = MultiSelectDropdownInput;
MultiSelectDropdownInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelectDropdownInput",
  "props": {
    "actionIconsPadding": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "containsErrors": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "getRemoveButtonProps": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "getToggleButtonProps": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "inputProps": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "itemToString": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "placeholder": {
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "removeItem": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "selectedItems": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": false
    }
  }
};